import {gsap} from 'gsap';

class AbstractView {

    protected _data:any;
    protected _element?:HTMLElement;
    protected _template:string;
    protected _id:string;
    protected _params:any;

    constructor(id: string, data: any, params: any) {
        this._data = data;
        this._id = id;
        this._element = undefined;
        this._template = '';
        this._params = params;
    }

    get id(){
        return this._id;
    }

    set element(element: HTMLElement | undefined) {
        this._element = element;
    }

    get element() {
        return this._element;
    }

    render() {
        this.element = document.createElement('div');
        this.element.innerHTML = this._template;
        this.element = this.element.firstChild as HTMLElement;
        if (this._element) {
            this._element.style.display = 'none';
        }
    }

    postRender() {}

    init() {}

    destroy() {}

    preload(completeCallback: () => void) {
        completeCallback();
    }

    show(callback: (() => void) | undefined = undefined) {
        //this._element.style.opacity = 0;

        if (this._element) {
            gsap.set(this._element,{autoAlpha:0, display: ''});
            //this._element.style.display = '';
            gsap.to(this._element, 0.3, {autoAlpha:1, onComplete:callback});
        }
        /*if(callback) {
            callback();
        }*/
    }

    hide(callback: (() => void) | undefined = undefined) {
        //this._element.style.display = 'none';

        if (this._element) {
            gsap.to(this._element, 0.3, {autoAlpha:0, onComplete:callback});
        }
        /*
        if(callback) {
            callback();
        }
        */
    }

}

export default AbstractView;
